import React, { useState } from 'react';
import Table from '../../../../../components/Table';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { deleteGroup } from '../../../../../general_redux/rentals/actions';
import { customClassification } from "../../../../../common/functions/utils";
import Loading from '../../../../../components/loading';
import ConfirmMessage from '../../../../../components/Confirmation';

const ViewGroups = (props) => {

  const dispatch = useDispatch();

  const groups = useSelector(({ rentals }) => rentals && rentals.groups).filter((row) => row.groupName !== 'Default');
  const loading = useSelector(({ rentals }) => rentals && rentals.actionForGroup);

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');
  const [deleteData, setDeleteData] = useState(null);
  const [confirmDel, setConfirmDel] = useState(false);

  const cols = [
    { lable: 'Name', key: 'groupName' },
    { lable: 'Colour', key: 'color' },
    { lable: 'Actions', key: '' },
  ];

  const deleteGroupData = (data) => {
    setDeleteData(data.id);
    setConfirmDel(true);
  };

  const ConfirmedDeleteGroup = () => {
    if (deleteData) {
      dispatch(deleteGroup(deleteData));
      setDeleteData(null);
    }
  };

  return (
    <div>
      <Loading loadingStatus={loading.loading} />
      <ConfirmMessage
        show={confirmDel}
        onHide={() => {
          setConfirmDel(false);
        }}
        confirmHeader={`Delete group`}
        confirmBody={`Are you sure you want to delete this group?`}
        onConfirmAct={() => {
          ConfirmedDeleteGroup();
          setConfirmDel(false);
        }}
      />
      <Container fluid>
        <Row className="justify-content-left">
          <Col xs={12} md={8} lg={8} xl={6} className={`p-0 pt-2`}>
            <Table
              cols={cols}
              rows={customClassification(groups, order, orderBy)}
              onEdit={props.editGroup}
              onDelete={deleteGroupData}
              order={order}
              setOrder={setOrder}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default ViewGroups;
